import React, { useState, useEffect } from "react";
import { Axios, Link, Modal } from "../../../Headers";
import WebBookContactForm from "./WebBookContact";

const WebBookSpecific = (props) => {
  const [server, setServer] = useState("");
  const [bookData, setBookData] = useState({});
  const [noResultFound, setNoResultFound] = useState(false);
  const [bookId, setBookId] = useState("");
  const [modelIsOpenForSubmit, setModelIsOpenForSubmit] = useState(false);
  const [modelIsOpenForResponse, setModelIsOpenForResponse] = useState(false);
  const [response, setResponse] = useState("");

  useEffect(() => {
    const serverName = window.$name;
    setServer(serverName);

    const bookIdFromProps = props.match.params.id;
    setBookId(bookIdFromProps);

    Axios.post(`//${serverName}/controller/GetWebBookByIdController.php`, {
      bookId: bookIdFromProps,
    })
      .then((res) => {
        if (res) {
          setBookData(res?.data[0]);
          if (res?.data?.length === 0) {
            setNoResultFound(true);
          } else {
            setNoResultFound(false);
          }
        }
        else{
          setNoResultFound(true);
        }
      })
      .catch((err) => {
        setNoResultFound(true);
        // Handle error
      });
  }, [props.match.params.id]);

  const handleResponse = (status, msg) => {
    setResponse(msg);
    setModelIsOpenForResponse(true);
    if (status) {
      setModelIsOpenForSubmit(false);
    }
  };

  return (
    <>
      {noResultFound && <div className="no-record">No record found</div>}
      {!noResultFound && (
        <div className="row mb-5">
          <div className="col-md-4" style={{ padding: "35px" }}>
            <div className="sort-card">
              {bookData?.image && (
                <div
                  className="so_top_icon"
                  style={{
                    width: "100%",
                    height: "45%",
                    borderRadius: "15px 15px 0 0",
                    backgroundImage: `url(${window.$file}webBooks/${bookData?.image})`,
                    backgroundSize: "cover",
                  }}
                ></div>
              )}
              <div style={{ padding: "25px", height: "55%" }}>
                <div className="sort-card-title">{bookData?.title}</div>
              </div>
            </div>
          </div>
          <div className="col-md-8" style={{ padding: "35px 0px 35px 35px" }}>
            <div>
              <p id="home-heading" style={{ fontSize: "35px" }}>
                Book Details
              </p>
              <div
                style={{
                  borderTop: "2px solid black",
                  width: "10%",
                  marginBottom: "20px",
                }}
              ></div>
            </div>
            <div style={{ padding: "0 0" }}>
              <p className="content_subheading">
                <b>Edition : </b>
                <span className="content">{bookData?.edition}</span>
              </p>
              <p className="content_subheading">
                <b>ISBN : </b>
                <span className="content">{bookData?.isbn}</span>
              </p>
              <p className="content_subheading">
                <b>Author : </b>
                <span className="content">{bookData?.author}</span>
              </p>
              <p className="content_subheading">
                <b>About : </b>
                <span className="content">{bookData?.about}</span>
              </p>
              {/* <p className="content_subheading cursor-pointer">
              <b>Buy Link : </b>
              <span id="home-contact-btn" onClick={() => setModelIsOpenForSubmit(true)}>
                Contact Us
              </span>
            </p> */}
              {bookData?.buyLink && (
                <p className="content_subheading cursor-pointer">
                  <b>Buy Link : </b>
                  <span
                    id="home-contact-btn"
                    onClick={() => window.open(bookData?.buyLink, "_blank")}
                  >
                    Buy
                  </span>
                </p>
              )}
            </div>
          </div>

          <div className="container-fluid d-flex justify-content-end">
            <button id="home-publish-btn">
              <Link to="/sortsollogin" style={{ color: "white" }}>
                Join Us
              </Link>
            </button>
          </div>
        </div>
      )}

      <Modal
        isOpen={modelIsOpenForSubmit}
        className="popup-modal-content-web-book-contact"
        overlayClassName="popup-modal"
        onRequestClose={() => setModelIsOpenForSubmit(false)}
      >
        <span
          className="closed"
          type="button"
          style={{
            fontSize: "32px",
            position: "absolute",
            zIndex: "1",
            right: "3%",
            height: "6.7vh",
            lineHeight: "6.7vh",
          }}
          onClick={() => setModelIsOpenForSubmit(false)}
        >
          &times;
        </span>
        <div
          className="card-header"
          id="ss-uad-article-10"
          style={{ justifyContent: "flex-start", paddingLeft: "5%" }}
        >
          <span id="ss-uad-article-12">Contact us</span>
        </div>
        <div className="card-body">
          <WebBookContactForm bookId={bookId} handleResponse={handleResponse} />
        </div>
      </Modal>
      <Modal
        isOpen={modelIsOpenForResponse}
        className="popup-modal-content-success"
        overlayClassName="popup-modal"
        onRequestClose={() => window.location.reload()}
      >
        <div className="row" style={{ height: "100%", margin: "0px" }}>
          <div className="col-9" style={{ paddingTop: "6px" }}>
            <p id="popup-title">Remark</p>
            <p id="popup-content">{response}</p>
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              id="ss-uad-article-09"
              style={{
                height: "50px",
                lineHeight: "initial",
                padding: "initial",
                width: "110px",
              }}
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              <i className="fas fa-check" style={{ fontSize: "29px" }}></i>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default WebBookSpecific;
